const humanizeIt = (value, { isByte, toFixed }) => {
  const base = isByte ? 1024 : 1000;
  const n = Math.pow(10, toFixed);
  const min = base / n;

  const steps = [min, Math.pow(base, 2), Math.pow(base, 3), Math.pow(base, 4)];

  if (value < min) {
    return `${value.toFixed(toFixed)}${isByte ? 'b' : ''}`;
  } else if (value.isInBetween({ max: steps[1], min: steps[0] })) {
    return `${(value / base).toFixed(toFixed)}${isByte ? 'Kb' : 'k'}`;
  } else if (value.isInBetween({ max: steps[2], min: steps[1] })) {
    return `${(value / steps[1]).toFixed(toFixed)}${isByte ? 'Mb' : 'm'}`;
  } else if (value.isInBetween({ max: steps[3], min: steps[2] })) {
    return `${(value / steps[2]).toFixed(toFixed)}${isByte ? 'Gb' : 'b'}`;
  } else {
    return `${(value / steps[3]).toFixed(toFixed)}${isByte ? 'Tb' : 't'}`;
  }
};

Number.prototype.fromAlphabet = function(character) {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return alphabet.indexOf(character.toUpperCase());
};

Number.prototype.isOutOf = function({ edge, max, min }) {
  const value = (this + 0);
  return edge === '[]'
    ? min >= value && value >= max
    : edge === '(]'
      ? min > value && value >= max
      : edge === '[)'
        ? min >= value && value > max
        : min > value || value > max;
};

Number.prototype.isInBetween = function({ edge, max, min }) {
  const value = (this + 0);
  return edge === '[]'
    ? min <= value && value <= max
    : edge === '(]'
      ? min < value && value <= max
      : edge === '[)'
        ? min <= value && value < max
        : min < value && value < max;
};

Number.prototype.format = function(cfg = {}) {
  const value = Number(this);
  cfg = {
    ...{ expThld: false, isByte: false, locale: 'en', readable: false, toFixed: 2 },
    ...cfg,
  };

  if (cfg.readable) {
    return humanizeIt(value, cfg);
  }

  const toReturn = isNaN(this)
    ? NaN
    : cfg.expThld && value < cfg.expThld
      ? value.toExponential(1)
      : value.toLocaleString(cfg.locale, {
        maximumFractionDigits: cfg.toFixed,
        minimumFractionDigits: cfg.toFixed,
      });

  return (toReturn === '0.0e+0' && (0).toFixed(cfg.toFixed)) || toReturn;
};

Number.prototype.toAlphabet = function() {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return (
    this >= alphabet.length
      ? ((this / alphabet.length >> 0) - 1).toAlphabet()
      : ''
  ) + alphabet[this % alphabet.length >> 0];
};

Number.prototype.toPercent = function(total, cfg = {}) {
  cfg = {
    ...{ round: false, toFixed: 2 },
    ...cfg,
  };
  return total && total > 0
    ? cfg.round
      ? Math.round((this / total * 100))
      : (this / total * 100).toFixed(cfg.toFixed)
    : 0;
};

export const isNumber = (input) => {
  return typeof input === 'number';
};

export default Number;
